import type { SVGProps } from 'react';

export function PepperIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.638 4.837a.9.9 0 0 0-1.271-1.271L19.158 4.77A5.98 5.98 0 0 0 15.6 3.6a6 6 0 0 0-3.521 1.14c-.6.439-.222 1.26.521 1.26h.9c.499 0 .9.401.9.9v3c0 .499.401.9.9.9h3c.499 0 .9.401.9.9v.9c0 .742.821 1.121 1.26.521A6 6 0 0 0 21.6 9.6a5.98 5.98 0 0 0-1.17-3.559zM11.324 7.481l-5.985 8.55a1.8 1.8 0 0 1-1.478.769H3.6a1.8 1.8 0 0 0 0 3.6h1.016c2.464 0 4.864-.758 6.882-2.168l6.22-4.353a2.7 2.7 0 0 1-.318-1.28h-2.1a2.7 2.7 0 0 1-2.7-2.7V7.8c-.457 0-.896-.112-1.275-.318" />
    </svg>
  );
}
